import { MOBILE_TILES_PER_PAGE } from '../global-constants';

/**
 * Return true if paging is needed.
 * Paging isn't needed if everything fits on one page, which covers having no
 * data at all (0 is never greater than a page size).
 * @param {Object} paging - Paging object with totalCount and pageSize
 * @returns {boolean}
 */
export const isPagingNeeded = (paging) =>
	Boolean(paging) && paging.totalCount > paging.pageSize;

/**
 * Slices data array for current page based on offset and pageSize
 * @param {Array} data - Full dataset
 * @param {number} offset - Starting index (0-based)
 * @returns {Array} Paginated data slice
 */
export const paginateData = (data, offset) => {
	if (!Array.isArray(data)) {
		return [];
	}

	const endIndex = Math.min(offset + MOBILE_TILES_PER_PAGE, data.length);
	return data.slice(offset, endIndex);
};
